"use client";

import { Loader2, Search } from "lucide-react";
import { SearchResultsContent } from "./SearchResults";
import type { GlobalSearch } from "./useGlobalSearch";

export function SearchPalette({ s }: { s: GlobalSearch }) {
  const { query, results, searchLoading, paletteMode, searchOpen, activeIndex, paletteInputRef, panelRef, flatItems, hasAnyResults, showResults, navigateTo, closeSearch, handleQueryChange, handleSearchKeyDown } = s;
  return (
    <>
      {paletteMode && searchOpen && (
        <>
          <div
            className="fixed inset-0 z-scrim bg-slate-900/10 dark:bg-neutral-950/50"
            onClick={closeSearch}
          />
          <div
            ref={panelRef}
            className="fixed inset-x-0 z-overlay flex flex-col items-center gap-2 px-4"
            style={{ bottom: "40%" }}
          >
            {showResults && (
              <div className="max-h-[45vh] w-full max-w-xl overflow-y-auto rounded-xl border border-line bg-surface shadow-xl ">
                <SearchResultsContent
                  results={results}
                  flatItems={flatItems}
                  activeIndex={activeIndex}
                  onSelect={navigateTo}
                  hasAnyResults={hasAnyResults}
                  loading={searchLoading}
                  query={query}
                />
              </div>
            )}
            <div className="flex w-full max-w-xl items-center gap-2 rounded-full border border-line-strong bg-surface-raised px-4 py-3 shadow-xl ring-1 ring-slate-900/5 focus-within:border-sky-400 focus-within:ring-2 focus-within:ring-sky-400/30 dark:focus-within:border-sky-500 dark:focus-within:ring-sky-500/30">
              {searchLoading ? (
                <Loader2 size={16} className="shrink-0 animate-spin text-subtle" />
              ) : (
                <Search size={16} className="shrink-0 text-subtle" />
              )}
              <input
                ref={paletteInputRef}
                type="text"
                value={query}
                placeholder="Search articles, applications, clients, tickets, feedback, users…"
                className="w-full min-w-0 bg-transparent text-sm text-fg placeholder:text-subtle focus:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
                onChange={(e) => handleQueryChange(e.target.value)}
                onKeyDown={handleSearchKeyDown}
              />
              <kbd className="hidden shrink-0 rounded-md border border-line px-1.5 py-0.5 text-xs font-medium text-subtle sm:inline ">
                Esc
              </kbd>
            </div>
          </div>
        </>
      )}
    </>
  );
}
